import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Queue } from "../_types/queue";
import { QueueMember } from "../_types/queue-member";

@Injectable({
    providedIn: 'root',
})

export class QueuesMembersService extends Service<QueueMember> {
  public override type = 'queueMembers';
  public override url = 'Voip/queueMembers';

}
